module.exports = __webpack_public_path__ + "static/img/logo.de43d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo.png
// module id = 194
// module chunks = 41